<template>
	<el-header>
		<div class="banner">
			<div class="block">
				<el-carousel trigger="click" height="740px" v-if="$route.path=='/'">
					<el-carousel-item v-for="(val,key) in $i18n.locale == 'zh'?banner.banner : $i18n.locale == 'en' ? banner.y_name : banner.e_name" :key="key">
						<el-image :src="val.image" fit="contain"></el-image>
						<!-- <img :src="val.image" alt=""> -->
					</el-carousel-item>
				</el-carousel>
				<el-carousel trigger="click" height="400px" v-else>
					<el-carousel-item v-for="(val,key) in $i18n.locale == 'zh'?banner1.banner : $i18n.locale == 'en' ? banner1.y_name : banner1.e_name" :key="key">
						<el-image :src="val.image" fit="contain"></el-image>
						<!-- <img :src="val.image" alt=""> -->
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<div :class="scrollTop>400?'mohade':'header'">
			<div class="logo">
				<el-image src="./static/image/logo.png" fit="contain"></el-image>
				<!-- <div class="info">
					<b>产品质量达国际先进水平</b>
					企业荣誉企业荣誉企业荣誉企业荣誉企业荣誉
				</div> -->
			</div>
			<div class="navs">
				<div class="tab">
					<router-link :to="{name:'index'}" class="link"> <span :class="$route.path=='/'?'mo':''">{{$t('nav.home')}}</span></router-link>
					<router-link :to="{name:'synopsis'}" class="link"><span :class="$route.path=='/AboutUs/synopsis'?'mo':''">{{$t('nav.about')}}</span></router-link>
					<router-link style="width: 100%;" :to="{name:'cro'}"  class="link"><span :class="$route.path=='/service/cro'?'mo':''">{{$t('nav.yan')}}</span></router-link>
					<router-link :to="{name:'product'}"  class="link"><span :class="$route.path=='/product'?'mo':''">{{$t('nav.pro')}}</span></router-link>
					<router-link :to="{path:'/NewsCenter/news1'}"  class="link"><span :class="$route.path=='/NewsCenter/news1'?'mo':''">{{$t('nav.new')}}</span></router-link>
					<router-link :to="{name:'about'}"  class="link"><span :class="$route.path=='/about'?'mo':''">{{$t('nav.jabout')}}</span></router-link>
					<router-link :to="{name:'contact'}"  class="link"><span :class="$route.path=='/contact'?'mo':''">{{$t('nav.contact')}}</span></router-link>
				</div>
				<div class="search">
					<el-image src="./static/image/search.png" fit="contain" @click="show=true"></el-image><span></span>
					<div class="language" @click="changeLocale(1)"> ZH </div><span></span>

					<div class="language" @click="changeLocale(2)"> EN <!-- <a href="http://www.tihondan.com/mobileen">EN</a> --> </div><span></span>
					<div class="language" @click="changeLocale(3)"> RU </div>
					<div class="input" v-if="show==true"><el-input v-model="input" :placeholder="$t('nav.iupt')" @change="$router.push({ path: '/search?keyword='+ input})"></el-input><el-image src="./static/image/cha.png" fit="contain" @click="show= false" style="width:41px;height:41px"></el-image></div>
				</div>
			</div>
		</div>
	</el-header>
</template>
<script>
	export default {
		data() {
			return {
				userinfo: '',
				banner:{},
				banner1:{},
				input:'',
				show:true,
				scrollTop:'',
			}
		},
		mounted() {
			this.getBanner()
			this.getBanner1()
			window.addEventListener('scroll', this.windowScroll)
		},
		methods: {
			windowScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				this.scrollTop=scrollTop
				// console.log(scrollTop);
			},
			//banner图
			getBanner() {
				var that = this;
				this.$axios
					.post("/api/index/banner", {
						position:0,
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.banner = ret.data.data;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			getBanner1() {
				var that = this;
				this.$axios
					.post("/api/index/banner", {
						position:1,
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.banner1 = ret.data.data;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			getInput(val){
				console.log(val)
				this.$router.push({
					path: "/search?keyword="+val
				}); 
			},
		    //语言
			changeLocale(e){
				console.log('',process.env.NODE_ENV)
				// console.log(this.$i18n.locale,'11111111')
				if(e == 1){
					this.$i18n.locale = 'zh';
					if (process.env.NODE_ENV == "development") {
						//开发环境
					} else if (process.env.NODE_ENV == "production") {
						//生产环境
						// window.location.href = 'https://tianhong.shandonghuixing.com/zh/#/';
					}
				}else if(e == 2){
					this.$i18n.locale = 'en';
					if (process.env.NODE_ENV == "development") {
						//开发环境
					} else if (process.env.NODE_ENV == "production") {
						//生产环境
						// window.location.href = 'https://tianhong.shandonghuixing.com/en/#/';
					}
				}else if(e == 3){
					this.$i18n.locale = 'ru';
					if (process.env.NODE_ENV == "development") {
						//开发环境
					} else if (process.env.NODE_ENV == "production") {
						//生产环境
						// window.location.href = 'https://tianhong.shandonghuixing.com/ru/#/';
					}
				}
					// window.location.href = 'http://www.tihondan.com/mobileen';

				return;
				if(this.$i18n.locale == 'en'){
					this.$i18n.locale = 'zh';
				}else{
					this.$i18n.locale = 'en';
				}
			}
		}

	}
</script>
<style lang="scss" scoped>
	.el-header {
		width: 100%;
		// height: 740px !important;
		padding: 0;
		position: relative;
		.banner {
			width: 100%;
			// height: 410px;

			.el-image {
				width: 100%;
				// height: 400px;
			}
		}
		.header {
			width: 100%;
			height: 80px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: fixed;
			left: 0;
			top: 0px;
            z-index: 999;
		
		}
		.mohade{
			width: 100%;
			height: 80px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: fixed;
			left: 0;
			top: 0px;
            z-index: 999;
			background: #004098;
		}
			.logo {
				width: 30%;
				height: 80px;
				// background: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: center;

				.el-image {
					width: 160px;
					height: 50px;
					margin-right: 30px;
				}
				.info {
					display: flex;
					flex-direction: column;
					font-size: 12px;
					color: #999;

					b {
						font-size: 16px;
						color: #666;
					}
				}
			}

			.navs {
				width: 70%;
				height: 80px;
				
				border-radius: 0px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.tab{
					color: #fff;
					display: flex;
					align-items: center;
					width: 80%;
					// padding-left: 20%;
					padding-left: 5%;
					justify-content: space-between;
					.link{
						width: 100%;
						color: #B3C6E0;
						text-align: center;
						cursor: pointer;
					}
					.mo{
						color: #fff;
						font-size: 18px;
					}
				}
				.search{
					color: #fff;
					display: flex;
					align-items: center;
					width: 20%;
					position: relative;
					.el-image{
						width: 22px;
						height: 22px;
					}
					.input{
						position: absolute;
						top: 60px;
						/* right: 100px; */
						right: 129px;
						width: 400px;
						display: flex;
						i{
						    // background: #fff;
							color: #fff;
							font-size: 25px;
							padding: 0 10px;
							border-radius: 8px;
							line-height: 41px;
						}
					}
					span{
						width: 0px;
						height: 16px;
						border: 1px solid #FFFFFF;
						margin: 0 10px;
					}
					.language{
						font-size: 16px;
						cursor: pointer;
					}
				}
			}
	
		.el-carousel__item h3 {
			color: #475669;
			font-size: 14px;
			opacity: 0.75;
			line-height: 150px;
			margin: 0;
		}

		.el-carousel__item:nth-child(2n) {
			background-color: #99a9bf;
		}
		
		.el-carousel__item:nth-child(2n+1) {
			background-color: #d3dce6;
		}
		.el-carousel__button{
		background-color:#004098!important;
	}	
		
	}
	
</style>



// WEBPACK FOOTER //
// src/components/common/navHead.vue